import { useMutation } from 'react-query';

import { validateLogin as mutationFn } from 'api/endPoints/validateLogin';
import { QueryParams } from 'api/mutations/login.mutation';

export const useMutationValidateLogin = () => {
    return useMutation<QueryResponse, QueryError, QueryParams>({
        mutationFn: (params) => mutationFn(params),
    });
};

interface QueryResponse {
    valid: boolean;
}
